/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from 'axios';
import { fetchArchiveStatus, sendToWs } from '../Websocket/actions';
import _ from 'lodash';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { setArchiveModeDate, setArchiveMode, setRunningArchive } from '../App/actions';
import { useDispatch, connect } from 'react-redux';
import { makeSelectArchiveModeDate } from '../App/selectors';
import { createStructuredSelector } from 'reselect';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useHasPermissions } from '../../../config/utils/hooks/useHasPermissions';
import { PERMISSIONS } from '../../../config/utils/permissions_roles/roles';
import { Warning, FileDownload } from '@mui/icons-material';
import { Buffer } from 'buffer';
import base64 from 'base-64';
import pako from 'pako';
import globalMessages from '../../../config/globalMessages';
import FormattedMessage from '../../components/TranslationWrapper';
import { ArchiveStartIcon, ArchiveStopIcon } from '../../components/reusable/Icons';

function ArchiveSlider(props) {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [runningArchive, setIsRunningArchive] = useState(false);

  const [inputDate, setInputDate] = React.useState(null);
  const [intervalStep, setIntervalStep] = React.useState(null);
  const CAN_LOAD_LINESTATUS = useHasPermissions(PERMISSIONS.CAN_LOAD_LINESTATUS);
  const CAN_ACCESS_SUPER_MEGA_ADMIN = useHasPermissions(PERMISSIONS.CAN_ACCESS_SUPER_MEGA_ADMIN);
  const MULTI_CONTROL = _.get(props, 'multiControl', false);
  const MULTI_CONTROL_OPTIONS = _.get(props, 'options', []);
  const [processIdentifier, setProcessIdentifier] = useState({});

  const stopRunningArchive = () => {
    setIsRunningArchive(false);
    dispatch(setRunningArchive(false));
  };

  const setData = (data) => {
    const maxV = _.get(data, 'size', 0);
    setValue(maxV > 0 ? maxV - 1 : 0);
    setMax(maxV > 0 ? maxV - 1 : 0);
    setMin(0);
    setMinDate(Date.parse(_.get(data, 'first', null)));
    setMaxDate(Date.parse(_.get(data, 'last', null)));
  };

  const arrowClick = (diff) => {
    stopRunningArchive();
    if (diff < 0) {
      // console.log('arrowClick "-" inputDate: ', inputDate, ' -> ', Date.parse(inputDate));
      const df = Date.parse(inputDate) - intervalStep;
      // console.log('####: ', getFormattedCurrentTime(new Date(df)));
      setInputDate(getFormattedCurrentTime(new Date(df)));
    } else {
      // console.log('arrowClick "+" inputDate: ', inputDate);
      const df = Date.parse(inputDate) + intervalStep;
      setInputDate(getFormattedCurrentTime(new Date(df)));
    }
  };

  const getDataRange = async () => {
    try {
      const { data } = await axios.get(`${window.location.origin}/api/v1/productionline/linestatus/get_size/`);
      setData(data);
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };
  useEffect(() => {
    if (props.archive) {
      getDataRange();
      if (!props.archiveModeDate) {
        dispatch(setArchiveModeDate(getFormattedCurrentTime(new Date())));
      }
    } else {
      setIsRunningArchive(false);
      dispatch(setRunningArchive(false));
    }
  }, [props.archive]);

  useEffect(() => {
    if (inputDate != null) {
      dispatch(setArchiveModeDate(inputDate));
    }
  }, [inputDate]);

  useEffect(() => {
    setInputDate(props.archiveModeDate);
    props.dispatch(fetchArchiveStatus(Date.parse(props.archiveModeDate), _.get(processIdentifier, 'processIdentifier', ''), !MULTI_CONTROL || !_.get(processIdentifier, 'merged', true)));
  }, [props.archiveModeDate, processIdentifier]);

  useEffect(() => {
    setIntervalStep(_.get(props, 'intervalStep', 6000));
  }, [props.intervalStep]);

  useEffect(() => {
    if (!runningArchive || !props.archive) {
      return;
    }

    const timer = setInterval(() => {
      const currentTs = Date.parse(inputDate || props.archiveModeDate);
      const step = 1000; // 1 sec steps for running through archive
      const nextTs = currentTs + step;

      setInputDate(getFormattedCurrentTime(new Date(nextTs)));
    }, 1000);

    return () => clearInterval(timer);
  }, [runningArchive, props.archive, inputDate, props.archiveModeDate, maxDate]);

  useEffect(() => {
    if (!MULTI_CONTROL || _.isEmpty(MULTI_CONTROL_OPTIONS) || !_.isEmpty(processIdentifier)) {
      return;
    }
    const defaultOption = MULTI_CONTROL_OPTIONS.find((option) => String(option?.identifier || '').toLowerCase() === 'all') || MULTI_CONTROL_OPTIONS[0];
    if (defaultOption) {
      setProcessIdentifier(defaultOption);
    }
  }, [MULTI_CONTROL, MULTI_CONTROL_OPTIONS, processIdentifier]);

  function addLeadingZero(toFormat) {
    let formatted = '';
    // console.log('toFormat: ', toFormat, " length: ",toFormat.length);
    formatted = toFormat.length == 1 ? ('0' + toFormat).slice(-2) : toFormat;
    return formatted;
  }

  const getFormattedCurrentTime = (timeToConvert) => {
    let today, dd, mm, yyyy, h, m, s;
    // eslint-disable-next-line prefer-const
    today = timeToConvert;
    dd = today.getDate();
    dd = addLeadingZero(String(dd));
    mm = today.getMonth() + 1;
    mm = addLeadingZero(String(mm));
    h = today.getHours();
    h = addLeadingZero(String(h));
    m = today.getMinutes();
    m = addLeadingZero(String(m));
    s = today.getSeconds();
    s = addLeadingZero(String(s));
    // eslint-disable-next-line prefer-const
    yyyy = today.getFullYear();

    const datetime = yyyy + '-' + mm + '-' + dd + 'T' + h + ':' + m + ':' + s;
    // console.log('datetime: ', datetime);
    return datetime;
  };

  const selectDate = (e) => {
    stopRunningArchive();
    setInputDate(e.target.value);
    const df = Date.parse(inputDate);
  };

  const handleProcessChange = (e) => {
    setProcessIdentifier(e.target.value);
  };

  const inputRef = useRef();
  const handleInputClick = () => {
    inputRef.current.showPicker();
  };

  const handleLoadStatusClick = () => {
    setConfirmationOpen(true);
  };

  const handleConfirm = () => {
    handleClose();
    dispatch(
      sendToWs(
        {
          statusTime: Date.parse(props.archiveModeDate),
          processIdentifier: _.get(processIdentifier, 'processIdentifier', '')
        },
        'load-archive-status'
      )
    );
    dispatch(setRunningArchive(false));
    dispatch(setArchiveMode(false));
    dispatch(setArchiveModeDate(''));
  };

  const handleClose = () => {
    setConfirmationOpen(false);
  };

  const handleDownloadStatusClick = async () => {
    try {
      const { data } = await axios.post(`/api/v1/productionline/linestatus/get_data/`, {
        statusTime: Date.parse(props.archiveModeDate),
        processIdentifier: _.get(processIdentifier, 'processIdentifier', ''),
        requireData: true
      });

      if (data.data) {
        const base64Data = data.data;
        const compressedData = base64.decode(base64Data);

        try {
          const decompressedData = pako.ungzip(Buffer.from(compressedData, 'binary'));
          const blob = new Blob([decompressedData], { type: 'application/octet-stream' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'lineStatus.json';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (err) {
          console.error('Error decompressing data:', err);
        }
      }
    } catch (error) {
      console.error('Error downloading status:', error);
    }
  };

  const handleToggleRunningArchive = () => {
    setIsRunningArchive((prev) => {
      dispatch(setRunningArchive(!prev));
      return !prev;
    });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <div>
        <FormattedMessage {...globalMessages.selectLinestatusTime} />
      </div>
      <Stack spacing={0} direction="column" sx={{ mb: 1 }} alignItems="center">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <NavigateBeforeIcon
            onClick={() => {
              arrowClick(-1);
            }}
          />
          <div>
            <input
              onClick={handleInputClick}
              ref={inputRef}
              style={{ background: '', width: '95%', fontSize: 'smaller', cursor: 'pointer' }}
              value={inputDate}
              onChange={selectDate}
              type="datetime-local"
              min={minDate != null ? getFormattedCurrentTime(new Date(minDate)) : getFormattedCurrentTime(new Date())}
              max={maxDate != null ? getFormattedCurrentTime(new Date(maxDate)) : getFormattedCurrentTime(new Date())}></input>
          </div>
          {/* <Slider min={min} max={max} aria-label="Volume" value={value} onChange={handleChange} onChangeCommitted={handleChangeCommited} /> */}
          <NavigateNextIcon
            onClick={() => {
              arrowClick(1);
            }}
          />
        </div>
        <Button sx={{ mt: 1 }} variant="contained" size="small" onClick={handleToggleRunningArchive} disabled={!inputDate && !props.archiveModeDate}>
          {runningArchive ? <ArchiveStopIcon fontSize="small" /> : <ArchiveStartIcon fontSize="small" />}
        </Button>

        {MULTI_CONTROL && (
          <FormControl
            fullWidth
            sx={{
              mt: 1.5,
              px: 1,
              '& .MuiInputLabel-root': { color: '#b9b9b9' },
              '& .MuiOutlinedInput-root': {
                color: '#e8e8e8',
                backgroundColor: '#2c2c2c',
                '& fieldset': { borderColor: '#4a4a4a' },
                '&:hover fieldset': { borderColor: '#d4bc74' },
                '&.Mui-focused fieldset': { borderColor: '#d4bc74' }
              },
              '& .MuiSvgIcon-root': { color: '#b9b9b9' }
            }}>
            <InputLabel id="select-process-label">
              <FormattedMessage {...globalMessages.selectedProcess} />
            </InputLabel>
            <Select
              labelId="select-process-select-label"
              id="select-process-select"
              value={processIdentifier}
              label="Process"
              onChange={handleProcessChange}
              size="small"
              MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
                PaperProps: {
                  sx: {
                    mt: 0.5,
                    ml: -1,
                    backgroundColor: '#2c2c2c',
                    color: '#e8e8e8',
                    border: '1px solid #4a4a4a',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.45)'
                  }
                }
              }}
              sx={{
                '& .MuiSelect-select': {
                  py: 0.6,
                  minHeight: 'auto',
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  pl: 3,
                  pr: 3
                },
                '& .MuiSelect-icon': { right: 8 }
              }}>
              {MULTI_CONTROL_OPTIONS.map((option) => (
                <MenuItem
                  key={option.processIdentifier || option.identifier}
                  value={option}
                  sx={{
                    fontSize: '0.78rem',
                    textAlign: 'center',
                    justifyContent: 'center',
                    '&.Mui-selected': { backgroundColor: 'rgba(212, 188, 116, 0.2)' },
                    '&.Mui-selected:hover': { backgroundColor: 'rgba(212, 188, 116, 0.3)' },
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.06)' }
                  }}>
                  {option.identifier}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {CAN_LOAD_LINESTATUS && (!MULTI_CONTROL || !_.get(processIdentifier, 'merged', true)) && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '14px',
              width: '100%',
              padding: '0 8px'
            }}>
            {CAN_ACCESS_SUPER_MEGA_ADMIN && (
              <Button sx={{ mb: 1 }} startIcon={<Warning />} variant="contained" size="small" color="error" fullWidth onClick={handleLoadStatusClick}>
                <FormattedMessage {...globalMessages.loadStatus} />
              </Button>
            )}
            <Button startIcon={<FileDownload />} variant="contained" size="small" color="info" fullWidth onClick={handleDownloadStatusClick}>
              <FormattedMessage {...globalMessages.downloadStatus} />
            </Button>
          </div>
        )}
      </Stack>
      <Dialog open={confirmationOpen} onClose={handleClose}>
        <DialogTitle>
          <b>
            <FormattedMessage {...globalMessages.confirmLoadStatus} />
          </b>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormattedMessage {...globalMessages.loadStatusQuestion} />
            <br />
            <strong>{props.archiveModeDate}</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error" variant="contained">
            <FormattedMessage {...globalMessages.cancel} />
          </Button>
          <Button onClick={handleConfirm} color="success" autoFocus variant="contained">
            <FormattedMessage {...globalMessages.confirm} />
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const mapStateToProps = createStructuredSelector({
  archiveModeDate: makeSelectArchiveModeDate()
});

export default connect(mapStateToProps)(ArchiveSlider);
